import { createApi } from '@reduxjs/toolkit/query/react'
import { FAVOURITE_SCHOOL_CLIENT, UPDATE_SCHOOL_CLIENT } from "config/apiPaths";
import { RTK_CACHE_EXPIRATION } from "config/constants";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const schoolClientsApi = createApi({
  reducerPath: 'schoolClientsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/client/school",
  }),
  tagTypes: ["SchoolClients", "SchoolClientDetails"],
  keepUnusedDataFor: RTK_CACHE_EXPIRATION,
  endpoints: (builder) => ({
    // get School clients list
    getSchoolClientsList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, division = "", school = "", grade = "", sort = { column: "id", direction: "ASC" } }) => {
        return ({
          method: "PATCH",
          url: "/list",
          data: {
            search,
            status: status?.value,
            page,
            limit,
            division,
            school: school?.value || "",
            grade: grade?.value || "",
            sort,
          },
        })
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolClients"]
    }),

    // get School profile
    getSchoolClientData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `/detail/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolClientDetails"]
    }),

    // update client
    updateSchoolClient: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_SCHOOL_CLIENT}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
    }),

    favouriteSchoolClient: builder.mutation({
      query: ({ data, id }) => ({
        method: "PATCH",
        url: `${FAVOURITE_SCHOOL_CLIENT}/${id}`,
        data
      }),
      invalidatesTags: ["SchoolClients", "SchoolClientDetails"]
    }),
  }),
})

export const {
  useGetSchoolClientsListQuery,
  useGetSchoolClientDataQuery,
  useLazyGetSchoolClientsListQuery,
  useUpdateSchoolClientMutation,
  useFavouriteSchoolClientMutation
} = schoolClientsApi;